import React from 'react';
import { ShoppingBag, HeartPulse, Coffee, Film, GraduationCap, Building2 } from 'lucide-react';
import { locationsData } from '../data/mock';

const iconMap = {
  'shopping-bag': ShoppingBag,
  'heart-pulse': HeartPulse,
  coffee: Coffee,
  film: Film,
  'graduation-cap': GraduationCap,
  'building-2': Building2
};

const Locations = () => {
  return (
    <section id="locations" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Nos Lieux de Présence
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trouvez une borne JYA partout où vous allez
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {locationsData.map((location, index) => {
            const Icon = iconMap[location.icon];
            return (
              <div 
                key={location.id}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Image background */}
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={location.image}
                    alt={location.type}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/70 to-transparent opacity-80" />
                
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-gray-900" />
                  </div>
                  
                  <h3 className="text-2xl font-bold mb-2">
                    {location.type}
                  </h3>
                  
                  <p className="text-gray-200 text-sm">
                    {location.description}
                  </p>
                </div>

                {/* Hover accent */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-yellow-500 rounded-bl-full transform translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500 opacity-0 group-hover:opacity-100" />
              </div>
            );
          })}
        </div>

        {/* Call to action */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-yellow-100 to-green-100 p-8 rounded-2xl border border-yellow-300">
            <p className="text-gray-800 text-lg mb-2">
              <span className="font-bold text-yellow-700">Nouveau lieu bientôt disponible ?</span>
            </p>
            <p className="text-gray-600">
              Nous ajoutons régulièrement de nouvelles bornes pour être toujours plus proches de vous
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
